import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDirectIncomeBalance,
  fetchDirectIncomeAccountsBySearch,
} from "./directIncomeBalanceThunk";

const initialState = {
  list: [],
  loading: false,
  incomeAccounts: [],
  incomeAccountLoading: false,
  balanceTotal: 0,
  filters: {
    filterType: "All Income Account", // "All Income Account" | "Income Account Wise" | "Date Wise"
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const directIncomeBalanceSlice = createSlice({
  name: "directIncomeBalance",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDirectIncomeBalance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDirectIncomeBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.incomes;
        state.balanceTotal = action.payload.total_balance;
      })
      .addCase(fetchDirectIncomeBalance.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchDirectIncomeAccountsBySearch.pending, (state) => {
        state.incomeAccountLoading = true;
      })
      .addCase(fetchDirectIncomeAccountsBySearch.fulfilled, (state, action) => {
        state.incomeAccountLoading = false;
        state.incomeAccounts = action.payload;
      })
      .addCase(fetchDirectIncomeAccountsBySearch.rejected, (state) => {
        state.incomeAccountLoading = false;
        state.incomeAccounts = [];
      });
  },
});

export const { setFilters } = directIncomeBalanceSlice.actions;
export default directIncomeBalanceSlice.reducer;
